<div class="col d-flex justify-content-center">
  <div class="card-icon mt-3">
    <div class="icone">
      <i class="fi" [class]="icon"></i>
    </div>
    <div class="content text-center">
      <h3>{{ title }}</h3>
      <p>{{ subTitle }}</p>
    </div>
  </div>
</div>
